import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=1a3c7eef&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=1a3c7eef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c7eef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3c7eef')) {
      api.createRecord('1a3c7eef', component.options)
    } else {
      api.reload('1a3c7eef', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=1a3c7eef&scoped=true&", function () {
      api.rerender('1a3c7eef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aARHhz913oDK/JS/comp/PopupBox.vue"
export default component.exports